import { Component, ViewChild, ElementRef } from '@angular/core';
import {
  IonicPage, NavController, NavParams,
  AlertController, Platform, ModalController
} from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { ProveedoresProvider } from '../../providers/proveedores/proveedores'
import { LoadingController } from 'ionic-angular';
import { CompaniasProvider } from '../../providers/companias/companias'
import { AuthService } from '../../providers/auth-service'
import { UtilsProvider } from '../../providers/utils/utils'
import { NUBE_AWS } from '../../config/url.servicio';

@IonicPage()
@Component({
  selector: 'page-proveedores',
  templateUrl: 'proveedores.html',
  providers: [ AuthService ]
})
export class ProveedoresPage {

identificacion: any
nombreEmpresa: any
nombre: any
direccion: any
numeroTelefono: any
descripcion: any
estado: any
proveedores = []
proveedoresId
queHago :any
name:any
nombreTabla :any
loader
typeImg
editarProveedor
nombreCompaniaHeader:any=""
nombreCargoHeader:any=""
constructor(public navCtrl: NavController, public navParams: NavParams,
  public alertControllers: AlertController,
  public platforms: Platform,
  public modalControllers: ModalController,
  public servicio: ProveedoresProvider,
  private storage: Storage,
  public loadingCtrl: LoadingController ,
  public servicioCompania:CompaniasProvider,
  public auth: AuthService,
  public utilidades: UtilsProvider
) {
    this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo'])
    .then((val)=>{
      if(val){
        this.nombreCompaniaHeader = val['nombreCompania']
        this.nombreCargoHeader = val['nombreCargo']
      }
    })
    this.cargarproveedores()
}

cargarproveedores() {
  this.proveedores = []
  this.storage.get('companiasId').then((val) => {
  this.servicio.buscarProveedoresPorEmpresa(val)
  .subscribe(
    res => {
      if(NUBE_AWS) {
        this.proveedores = JSON.parse(res['_body']).data[0] === undefined ? [] : JSON.parse(res['_body']).data[0]
      } else {
        this.proveedores = res
      }
    },
    err => {
      let alert = this.alertControllers.create({
        title: 'Error',
        subTitle: 'No se pudieron listar los proveedores, intente luego',
        buttons: ['Cerrar']
      });
      alert.present();
    }
  )
 })
}

guardar() {

  // this.loader = this.loadingCtrl.create({});
  // this.loader.present();

  let datosProveedor: any = {
    identificacion : this.identificacion,
    nombreEmpresa : this.nombreEmpresa,
    nombre : this.nombre,
    direccion : this.direccion,
    numeroTelefono : this.numeroTelefono,
    descripcion : this.descripcion,
    estado : this.estado,
    queHago : this.editarProveedor ? "A" : "I",
    name :"dataDynamicCrud",
    nombreTabla : "proveedores"
  }
    if(this.editarProveedor){
      this.editarProveedor = false;
      this.editarProduct(datosProveedor)
    } else {
      this.guardarProveedor(datosProveedor)
    }

}

editarProduct(datosProveedor) {
  this.storage.get('companiasId').then((val) => {
    datosProveedor['companiasId']  = val
    datosProveedor['proveedoresId'] = this.proveedoresId

    this.servicio.actualizar(datosProveedor)
    .subscribe(
      res => {this.procesarResultado()
        this.utilidades.mensajeMuestro('PROVEEDORES','Proveedor actualizado con éxito!','success')
      },
      err => this.mostrarMensajeDeError('No se pudo actualizar el Proveedor, intente luego')
    )

  })

}

guardarProveedor(datosProveedor){
  this.storage.get('companiasId').then((val) => {
    datosProveedor['companiasId']  = val
  this.servicio.guardar(datosProveedor)
  .subscribe(
    res => {this.procesarResultado()
      this.utilidades.mensajeMuestro('PROVEEDORES','Proveedor almacenado con éxito!','success')        },
    err => this.mostrarMensajeDeError('No se pudo guardar el Proveedor, intente luego')
  )
})
}

limpiar() {
   this.identificacion = "";
   this.nombreEmpresa = "";
   this.nombre = "";
   this.direccion = "";
   this.numeroTelefono = "";
   this.descripcion = "";
   this.estado = ""
}

editar(item){
  this.identificacion = item.identificacion;
  this.nombreEmpresa = item.nombreEmpresa;
  this.nombre = item.nombre;
  this.direccion = item.direccion;
  this.numeroTelefono = item.numeroTelefono;
  this.descripcion = item.descripcion;
  this.estado = item.estado;
  this.editarProveedor = true;
  this.proveedoresId = item.proveedoresId;
  this.queHago = "A";
  this.name = "dataDynamicCrud";
  this.nombreTabla = "proveedores";
}

eliminar(item) {
  // this.loader = this.loadingCtrl.create({});
  // this.loader.present();

  let datosProveedor: any = {
    proveedoresId : item.proveedoresId,
    queHago : "E",
    name : "dataDynamicCrud",
    nombreTabla : "proveedores"
  }

  this.utilidades.mensajeConfirmacion('PROVEEDORES','¿Está seguro de eliminar el Proveedor?','warning',["Cancelar","Aceptar"],false)
  .then((loBorro:boolean) => {
    if(loBorro){
      this.servicio.eliminar(datosProveedor)
      .subscribe(
        res => {this.procesarResultado()
          this.utilidades.mensajeMuestro('PROVEEDORES','Proveedor eliminado con éxito!','success')
        },
        err => this.mostrarMensajeDeError('No se pudo eliminar el Proveedor, intente luego')
      )
    }
    else {
      this.utilidades.mensajeMuestro('PROVEEDORES','No se eliminó el proveedor','warning')
    }
  })

}

procesarResultado() {
  this.limpiar()
  // this.loader.dismiss()
  this.cargarproveedores()
}

mostrarMensajeDeError(mensaje) {
    let alert = this.alertControllers.create({
      title: 'Error',
      subTitle: mensaje,
      buttons: ['Cerrar']
    });
    alert.present();
    // this.loader.dismiss()
  }
  cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/proveedores/proveedores.ts